var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "footerWrap", class: { bookStyle: _vm.bookStyle } },
    [
      _c("div", { staticClass: "row-wrap custom-container" }, [
        _c("div", { staticClass: "row-left" }, [
          _c("a", { attrs: { href: "mailto:service@astroinfo.com.tw" } }, [
            _c("div", { staticClass: "email" }, [
              _vm.bookStyle
                ? _c("img", {
                    attrs: {
                      src: require("@/assets/運勢書共用/social_email.svg")
                    }
                  })
                : _c("img", {
                    attrs: { src: require("@/assets/icon_email.svg") }
                  })
            ])
          ]),
          _c("div", { staticClass: "links" }, [
            _c("div", { staticClass: "link", on: { click: _vm.toReport } }, [
              _vm._v("问题回报")
            ]),
            _c("div", { staticClass: "link", on: { click: _vm.toPrivacy } }, [
              _vm._v("隐私及服务条款")
            ])
          ])
        ])
      ]),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright" }, [
      _c("span", [
        _vm._v(
          "\n      © ASTRORG 星学会展示网站。 本网站仅供业务开发、合作提案与产品展示使用。网站内容包含客制化星盘服务、产品概念、流量变现模型与合作案例示意；相关数据已依保密原则进行汇整或比例化处理，仅供潜在合作伙伴评估参考。实际服务内容、合作条件、授权方式与商业模式，将以双方正式合同为准。\n    "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }